export function $UseBehavior(behaviorName, options) {
  return {
    [behaviorName]: options
  };
}
export function $UseBehaviorTag(component) {
  return {
    component,
    name: typeof component === 'string' ? component : undefined
  };
}